import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=7c650952&scoped=true&"
import script from "./Deliver.vue?vue&type=script&lang=js&"
export * from "./Deliver.vue?vue&type=script&lang=js&"
import style0 from "./Deliver.vue?vue&type=style&index=0&id=7c650952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c650952",
  null
  
)

export default component.exports